<template>
  <div class ="circle-signin" id= "linkedin-circle" @click="onClick">
    <img class = "circle-logo" src="/static/images/signin/linkedin/linkedin-icon.png"><!--id="linkedin"-->
  </div>
</template>

<style>
/* @import "~scss/social.scss"; */

#linkedin-circle:hover{
    cursor: pointer;
}
.circle-logo{
    width:35px;
}
</style>
</style>


<script>
import {stringify} from 'qs';
import {mapActions} from 'vuex';

export default {
  data() {
    return {ready: true};
  },
  mounted() {
    window.onOauth = (provider, {code}) => {
      this.$emit('login', {provider, code});
    };
  },
  beforeDestroy() {
    delete window.onOauth;
  },
  methods: {
    onClick() {
      const base = 'https://www.linkedin.com/oauth/v2/authorization';
      const params = {
        response_type: 'code',
        client_id: '86em1vwv504o9r',
        redirect_uri: window.location.origin + '/oauth/linkedin',
        state: '987654321', // we don't check this so no point making it random
        scope: 'r_basicprofile r_emailaddress'
      };
      const url = `${base}?${stringify(params)}`;
      window.open(url, 'linkedinAuth', 'width=600,height=400');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/shared/LinkedInCircle.vue